import Vue from 'vue';
import { levels } from "../services/level.service";
import { scopes } from "../services/scope.service";
import { states } from "../services/state.service";
import { boxTypes } from "../services/type.service";
import { territorial } from "../services/territorial.service";

Vue.filter('levelDescription', function (value) {
    let level = levels.find(lev => lev.id == value)
    let ret = level ? level.description : '-'
    return ret;
});

Vue.filter('scopeDescription', function (value) {
    let scope = scopes.find(s => s.id == value)
    let ret = scope ? scope.description : '-'
    return ret;
});

Vue.filter('typeDescription', function (value) {
    let boxType = boxTypes.find(s => s.id == value)
    let ret = boxType ? boxType.description : '-'
    return ret;
});
Vue.filter('territorialDescription', function (value) {
    let terr = territorial.find(s => s.id == value)
    let ret = terr ? terr.description : ''
    return ret;
});

Vue.filter('territorialUrl', function (value) {
    let terr = territorial.find(s => s.id == value)
    let ret = terr ? terr.url : ''
    return ret;
});

Vue.filter('dimensionDescription', function (value) {
    let found = ''
    scopes.forEach(s => {
        if (s.dimensions) {
            let dim = s.dimensions.find(d => d.id == value)
            if (dim) {
                found = dim.description
            }
        }
        
    })
    return found;
});

Vue.filter('competenceDescription', function (value) {
    let found = ''
    scopes.forEach(s => {
        if (s.dimensions) {
            s.dimensions.forEach(d => {
                if (d.competences) {
                    let com = d.competences.find(c => c.id == value)
                    if (com) {
                        found = com.description
                    }
                }
            })
        }        
    })
    return found;
});

Vue.filter('stateDescription', function (value) {
    let state = states.find(s => s.id == value)
    let ret = state ? state.description : '-'
    return ret;
});





// WEBPACK FOOTER //
// ./src/services/descriptions.filters.js